<template>
  <div>

    <v-stepper flat class="borderless shadowless" value="3">
      <v-stepper-header flat class="borderless shadowless">
        <v-stepper-step step="1" complete>Détails préliminaires</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="2" complete>Ajouter les responsables</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="3">Ajouter les participants</v-stepper-step>

        <!-- <v-divider></v-divider>

        <v-stepper-step step="4">Notification de rappel</v-stepper-step> -->
      </v-stepper-header>
    </v-stepper>
    <br>

    <v-snackbar v-model="snackbar" :timeout="snackbar_timeout" :color="snackbar_color" :top="true">
      {{ snackbar_message }}
    </v-snackbar>

    <v-card class="mb-3" flat>
      <v-card-title class="petit-size">
        <span class="primary--text">Liste des invités</span>
        <span v-if="selected" class="ml-3">{{ selected.length }} sélectionnés</span>
        <v-spacer></v-spacer>

        <v-text-field v-model="search_name" label="Filter par nom" solo @keyup="searchWithDelay()" class="mr-2">
        </v-text-field>

      </v-card-title>
    </v-card>

    <v-card flat class="mt-1 mb-1">
      <v-card-text>
        <v-form ref="form_participant" lazy-validation @submit.prevent="">

          <v-container grid-list-md text-xs-center>
            <v-layout row wrap>

              <v-flex xs3>
                <v-autocomplete v-model="search_department" :items="liste_dep" item-text="name" item-value="id" clearable
                  solo label="Département" @change="reloadData($event)"></v-autocomplete>
              </v-flex>

              <v-flex xs3>
                <v-autocomplete v-model="search_municipality" :items="liste_commune" item-text="name" item-value="id"
                  clearable solo label="Commune" @change="reloadData($event)"></v-autocomplete>
              </v-flex>

              <v-flex xs3>
                <v-autocomplete v-model="search_district" :items="liste_arrond" item-text="name" item-value="id" clearable
                  solo label="Arrondissement" @change="reloadData($event)"></v-autocomplete>
              </v-flex>

              <v-flex xs3>
                <v-btn color="primary" @click="fetchAllActors()">
                  <v-icon>mdi-reload</v-icon>
                  Réinitialiser la liste</v-btn>
              </v-flex>

            </v-layout>
          </v-container>
        </v-form>

      </v-card-text>
    </v-card>

    <v-data-table v-if="actors" v-model="selected" :headers="headers" :items="actors" show-select item-key="id"
      class="elevation-1 mr-10" :search="search" :page.sync="pagination.current" :items-per-page="10"
      @page-count="pagination.last_page = $event">
      <template v-slot:item.maillons="{ item }">
        <td>
          {{ item.maillons.map(item => item.name).join(', ') }}
        </td>
      </template>
    </v-data-table>

    <div class="text-xs-center mt-2">
      <v-pagination v-model="pagination.current" :length="pagination.last_page" @input="onPageChange"
        total-visible="16"></v-pagination>
    </div>

    <div class="text-center mt-5">
      <v-btn rounded color="info" @click="previousStep()" class="mx-3"> Précédent</v-btn>
      <v-btn rounded color="primary" class="white--text" @click="newEvent3()">Enregistrer et Continuer</v-btn>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Permissions from '~/mixins/Permissions'

export default {
  name: 'create-event-3',
  mixins: [Permissions],
  data: () => ({
    current_evenement: {},
    selected: [],
    headers: [
      {
        text: 'Nom complet',
        align: 'center',
        value: 'full_name'
      },
      { text: 'Maillon', value: 'maillons', align: 'center' },
      { text: 'Département', value: 'department.name', align: 'center' },
      { text: 'Commune', value: 'municipality.name', align: 'center' },
      { text: 'Arrondissement', value: 'district.name', align: 'center' },
      { text: 'Village', value: 'town.name', align: 'center' }
    ],

    search: '',
    search_department: null,
    search_municipality: null,
    search_district: null,

    snackbar: false,
    snackbar_message: '',
    snackbar_timeout: 5000,
    snackbar_color: '',
    pagination: {
      current: 1,
      last_page: 0,
      total: 0
    },
    searchTimer: null,
    search_name: '',
  }),

  computed: {
    actors() {
      let liste = this.$store.getters.getActors;
      this.pagination.current = liste.current_page;
      this.pagination.last_page = liste.last_page;
      this.pagination.total = liste.total;
      return liste.data;
    },

    liste_dep() { return this.$store.getters.departments; },
    liste_commune() { return this.$store.getters.municipalities; },
    liste_arrond() { return this.$store.getters.districts; },
  },

  created() {
    this.$checkPermission('create events')
    this.fetchUtils();
  },

  mounted() {
    this.checkRegistering();
  },


  methods: {
    fetchUtils() {
      let evenement = this.$store.getters.getNewEvent;
      this.current_evenement = evenement;
      let objet = {};
      objet.chain_ids = evenement.chain_ids;
      objet.page = this.pagination.current;

      this.$store.dispatch("loadActors", objet);

      this.$store.dispatch("fetchDepartments");
      this.$store.dispatch("fetchMunicipalities");
      this.$store.dispatch("fetchDistricts");
    },

    onPageChange() {
      let objet = {};
      objet.chain_ids = this.current_evenement.chain_ids;
      objet.page = this.pagination.current;
      this.$store.dispatch("loadActors", objet);
    },

    fetchAllActors() {
      let objet = {};
      objet.chain_ids = this.current_evenement.chain_ids;
      objet.page = this.pagination.current;
      this.$store.dispatch("loadActors", objet);
      this.selected = [];
    },

    checkRegistering() {
      var new_event = this.$store.getters.getActorsNewEvent;
      if (new_event != null) {
        this.selected = new_event;
      }
    },

    toggleAll() {
      if (this.selected.length) this.selected = []
      else this.selected = this.actors.slice()
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },

    async newEvent3() {
      if (this.selected.length == 0) {
        this.snackbar = true;
        this.snackbar_color = 'error';
        this.snackbar_message = "Veuillez sélectionner au moins un participant";
        return;
      }
      else {
        this.loadingSave = true;

        await this.$store.dispatch('storeEvent3', this.selected);

        // // Save event first
        await this.$store.dispatch("createEvent").then(value => {
          this.loadingSave = false;
          if (value == true) {
            this.$router.push({
              name: "events.coming",
              params: { new_event_added: value }
            });
          } else {
            console.log("Something went wrong!");
          }
        });
        // this.$store.dispatch('storeEvent3', this.selected);
        // this.$router.push({ name: 'events.new-4'/*, params: { Pid: value }*/ })
      }

    },

    previousStep() {
      this.$router.push({ name: 'events.new-2'/*, params: { Pid: value }*/ })
    },

    reloadData(value) {
      let objet = {};
      objet.chain_ids = this.current_evenement.chain_ids;

      if (this.search_department !== undefined && this.search_department !== null) {
        objet.department_id = this.search_department;
      }

      if (this.search_municipality !== undefined && this.search_municipality !== null) {
        objet.municipality_id = this.search_municipality;
      }

      if (this.search_district !== undefined && this.search_district !== null) {
        objet.district_id = this.search_district;
      }

      if (this.search_name.length !== 0) {
        objet.search_name = this.search_name;
      }

      objet.page = this.pagination.current;
      this.$store.dispatch("loadActors", objet);
    },

    searchWithDelay() {
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
        this.searchTimer = null;
      }
      this.searchTimer = setTimeout(() => {
        this.reloadData()
      }, 3000);
    }

  }
};
</script>

<style >
.petit-size {
  font-size: 1em;
  font-weight: bold;
}

thead {
  background-color: #78B943;
}

thead th {
  color: #fff !important;
}

thead th i {
  color: #fff !important;
}

.theme--light.v-subheader {
  font-size: 1.3em;
  color: black;
}

.v-pagination {
  flex-wrap: wrap;
}
</style>




// WEBPACK FOOTER //
// resources/assets/js/pages/events/create-3.vue